import React, { useState, useEffect, useRef } from 'react'
import { Button, Dropdown, PickerView, List, InfiniteScroll, SearchBar } from 'antd-mobile'
import { getAreaData, queryFlagshipStore } from "api/api";
import shopArea from "static/images/shopArea.svg";
import "static/css/shop.css";

export function Shop() {
  const ref = useRef()
  const [addArea, setAddArea] = useState('请选择地市')
  const [options, setOptions] = useState();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true)
  const [searchName, setSearchName] = useState('');
  const params = {
    address: addArea === '请选择地市' ? '' : addArea,//地市
    name: searchName,//搜索名称
    pageIndex: page,//页码
    pageSize: 10,//每页大小
  };

  //获取选择地市的内容
  async function getColumns() {
    const option = await getAreaData(20)
    const newOption = option.map(item => (
      { label: item.FNAME, value: item.ID }))
    setOptions(newOption)
  }

  //点击确认按钮关闭选择框
  function handleDropdownClick() {
    ref.current?.close()
  }

  // 获取列表数据、列表上拉加载
  async function loadMore() {
    const { list } = await queryFlagshipStore(params)
    if (list) {
      setPage(page + 1)
      setData([...data, ...list])
      setHasMore(list.length > 0)
    }
  }

  useEffect(() => {
    getColumns()
  }, []);

  // 初始化数据
  useEffect(() => {
    setPage(1)
    setHasMore(true)
    setData([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addArea, searchName]);
  // useEffect(() => {
  //   getShopList(params)
  //   // setPageIndex(1)
  //   // setHasMore(true)
  //   // setData([])
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [params]);

  return (
    <>
      <Dropdown ref={ref} className='text'>
        <Dropdown.Item key='sorter' title={addArea}>
          <div className='optionArea'>
            <PickerView
              columns={[options]}
              onChange={(val, extend) => {
                setAddArea(extend.items[0].label)
              }}
            />
            <Button
              color='primary'
              size='mini'
              className='optionAreaBut'
              onClick={handleDropdownClick}
            >
              确认
            </Button>
          </div>
        </Dropdown.Item>
        <div className='selectArea'>
          <SearchBar
            className='searchBar'
            placeholder='搜机构名称'
            onSearch={value => setSearchName(value)}
            onChange={value => value === '' && setSearchName('')}
          />
        </div>
      </Dropdown>
      <List className='shopList'>
        {
          data !== [] && data.map(item =>
            <List.Item key={item.forgname}>
              <div className="areaTitle">
                <img src={shopArea} alt='图标'></img >
                {item.forgname}
              </div>
              <div className="areaCont">地址：{item.faddress}</div>
              <div className="areaCont">联系电话：{item.ftel}</div>
              <div className="areaCont">服务时间：{item.fservicetime}</div>
            </List.Item>)
        }
      </List>
      <InfiniteScroll loadMore={() => loadMore()} hasMore={hasMore} />
    </>
  )
}